export const capitalize = (string: string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const capitalizeAndJoinWords = (words: string[]) =>
  words.map((word) => capitalize(word)).join(", ");
